<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZSIDHG/images/9781481457163.jpg?1717895993181" alt="This image is the cover for the book Piper Morgan to the Rescue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Piper Morgan to the Rescue
      </h1>
      <p class="bookDescription body article font2">
        <b>Piper helps some four-legged friends find the perfect home in the third book of the brand-new Piper Morgan series.</b><br/><br/>Piper is super excited to help out at Bark Street, a local animal shelter in town. Who wouldn’t want to be surrounded by adorable puppies and dogs all day? And when Piper sees Taffy, the cutest dog she has ever seen, Piper is determined to find a way to bring Taffy home. But it won’t be easy—especially when she finds out someone else wants to make Taffy a part of their family, too!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Faris, Lucy Fleming
      </h2>
      
      <p class="authorDescription body article">Stephanie Faris knew she wanted to be an author from a very young age. In fact, her mother often told her to stop reading so much and go outside and play with the other kids. After graduating from Middle Tennessee State University, she somehow found herself working in information technology. But she never stopped writing. When she isn&rsquo;t crafting fiction, Stephanie is indulging her gadget geek side by writing for online technology sites. Her work is regularly featured on the small business blogs for Intuit and Go Payment, and she is a featured columnist for SmallBizTechnology.com. She lives in Nashville with her husband.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4c6aef2